import AttestationLetterModule from '@features/Consular/components/attestation-letter/AttestationLetter.Module';
import React from 'react';

const AttestationLetter = () => {
  return <AttestationLetterModule />;
};

export default AttestationLetter;
